import React from "react";
import "./basketballinstructionblock.css"; // if you have styling
import { Link } from "react-router-dom";
import { useInstructions } from "../../../APIContext/InstructionsContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import bg_right from "../../../Assets/Images/BasketBallInstruction/right.png";
import bg_left from "../../../Assets/Images/BasketBallInstruction/left.png";

const BasketBallInstructionBlock = () => {
  const { packages, fetchGroupInstructions } = useInstructions();
  const navigate = useNavigate();
  const leftItems = [1, 3];

  useEffect(() => {
    fetchGroupInstructions();
  }, []);

  const getNavigationFn = (id, pid) => {
    if (id === 0) {
      window.location.href = `/group-instruction?id=${pid}`;
    } else if (id === 1) {
      window.location.href = `/individual-instruction?id=${pid}`;
    } else if (id === 2) {
      window.location.href = `/unlimited-instruction?id=${pid}`;
    } else if (id === 3) {
      window.location.href = `/team-workout?id=${pid}`;
    }
  };

  console.log("packages", packages);

  return (
    <>
      {packages
        ?.filter((item) => item.display_order !== 3)
        .map((i) => (
          <div
            className={`basketballinstructionblock-ss-block-ui ${leftItems.includes(i.id) ? "right" : "left"}`}
            style={{
              backgroundImage: `url(${leftItems.includes(i.id) ? bg_left : bg_right})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
            }}
          >
            <div className="ssb-img">
              <img src={i.image_big_card} />
            </div>

            {/* Content */}
            <div className="ssb-cnt">
              <div className="ssb-title">
                <h2 className="text-clip">{i.name}</h2>
              </div>

              <div className="ssb-desc">
                <p className="text-clip" style={{ marginBottom: "20px" }}>
                  {i.description}
                </p>
              </div>

              {i.display_order === 1 || i.display_order === 2 ? <hr /> : null}

              {i.display_order === 1 ? (
                <div className="ssb-title ssb-title-2">
                  <h2 className="text-clip">INDIVIDUAL INSTRUCTION SESSIONS</h2>
                </div>
              ) : null}

              <div className="ssb-desc">
                {i.display_order === 0 ? (
                  <p className="text-clip" style={{ color: "#EC6333" }}>
                    Benefits of Group Instruction
                  </p>
                ) : null}
              </div>

              <div className="ssb-desc">
                {i.display_order === 2 ? (
                  i.benefits?.map((i) => <p className="text-clip">{i}</p>)
                ) : (
                  <ul>
                    {i.benefits?.map((i) => (
                      <li className="text-clip">{i}</li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="ssb-desc">
                <Link
                  onClick={() => getNavigationFn(i.display_order, i.id)}
                  className="vb-btn"
                >
                  <span className="text-clip">Select Package</span>
                </Link>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default BasketBallInstructionBlock;
